import { formatMoney, getSizedImageUrl } from '//www.liquid-life.de/cdn/shop/t/94/assets/theme.js?v=27372344513999645111746606423';

$(document).ready(function () {
  // MH 01.12.2023
  // MASKING THIRD LEVEL LINKS IN MEGA MENU
  var variants = document.querySelectorAll('[data-href]');
  for (let i = 0; i < variants.length; i++) {
    variants[i].addEventListener("click", function() {
      location.href = this.getAttribute('data-href');
    });
  }

  // MH 01.12.2023
  // MASKING VARIANT LINKS
  var variants = document.querySelectorAll('[data-variant-href]');
  for (let i = 0; i < variants.length; i++) {
    variants[i].addEventListener("click", function() {
      location.href = this.getAttribute('data-variant-href');
    });
  }


  $('.swiper-container').each(function (i, e) {
    var mySwiper = new Swiper($('.swiper-container')[i], {
      // Optional parameters
      loop: true,
      spaceBetween: 10,
      slidesPerView: 8,
      breakpoints: {
        320: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 5
        },
        768: {
          slidesPerView: 6
        },
        992: {
          slidesPerView: 7
        },
        1200: {
          slidesPerView: 8
        }
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination'
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });
});


/*Hasaan @LatoriGMBH*/
class ProductConnector extends HTMLElement {
  constructor() {
    super();

    // Get references to the elements within the existing element
    this.spanElement = this.querySelector('[data-current-option]');
    this.aElements = this.querySelectorAll('a');

    if (!this.spanElement) {
      return;
    }

    // Capture the default text content
    this.defaultText = this.spanElement.textContent;

    // Add event listeners to the <a> elements
    this.aElements.forEach((a) => {
      a.addEventListener('mouseover', () => {
        // Change the textContent of the <span> element on hover
        this.spanElement.textContent = a.getAttribute('data-option');
      });

      a.addEventListener('mouseout', () => {
        // Reset the textContent of the <span> element to the default text
        this.spanElement.textContent = this.defaultText;
      });
    });
  }
}

// Register the custom element (if not already registered)
window.customElements.define('product-connector', ProductConnector);


class CountDownTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute('data-enddate'));
    this.initialHtml = this.innerHTML;
    if (this.endTime != '') {
      this.init();
      this.startCountdown();
    }
  }

  init() {
    const today = new Date();
    let difference = this.endTime - today;
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    this.days = Math.floor(difference / millisecondsInADay);
    const remainingMilliseconds = difference % millisecondsInADay;
    this.hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    this.minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);
    this.innerHTML = this.getString(this.initialHtml);
    this.setAttribute('inited', true);
  }

  getString(replaceText) {
    const days = this.days;
    const hours = this.hours;
    const minutes = this.minutes;
    const seconds = this.seconds;

    replaceText = replaceText.replace(/\[dd\]/g, days);
    replaceText = replaceText.replace(/\[hh\]/g, hours);
    replaceText = replaceText.replace(/\[mm\]/g, minutes);
    replaceText = replaceText.replace(/\[ss\]/g, seconds);
    return replaceText;
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.days <= 0 && this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) {
        this.innerHTML = '';
        clearInterval(this.countdownInterval);        
        // Check if the timer is inside a div with the class shopify-section--announcement-bar
        const announcementBar = this.closest('.shopify-section--announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        const uspBar = document.querySelector('.usp-bar-wrapper');
        if (uspBar) {
          uspBar.removeAttribute('hidden');
        }
      } else {
        this.init();
      }
    }, 1000);
  }

  disconnectedCallback() {
    // Stop the interval when the element is removed
    clearInterval(this.countdownInterval);
  }
}

// Define the custom element
customElements.define('countdown-timer', CountDownTimer);


class CountDownTimerPrice extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute('data-enddate'));
    this.initialHtml = this.innerHTML;
    if (this.endTime != '') {
      this.init();
      this.startCountdown();
    }
  }

  init() {
    const today = new Date();
    let difference = this.endTime - today;
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    this.daysinhours = Math.floor(difference / millisecondsInADay)*24;
    const remainingMilliseconds = difference % millisecondsInADay;
    this.hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60))+this.daysinhours;
    this.minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);
    this.innerHTML = this.getString(this.initialHtml);
    this.setAttribute('inited', true);
  }

  getString(replaceText) {
    const hours = this.hours;
    const minutes = String(this.minutes).padStart(2, '0');
    const seconds = String(this.seconds).padStart(2, '0');

    replaceText = replaceText.replace(/\[hh\]/g, hours);
    replaceText = replaceText.replace(/\[mm\]/g, minutes);
    replaceText = replaceText.replace(/\[ss\]/g, seconds);
    return replaceText;
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) {
        this.innerHTML = '';
        clearInterval(this.countdownInterval);        
        // Check if the timer is inside a div with the class shopify-section--announcement-bar
        const announcementBar = this.closest('.shopify-section--announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        const uspBar = document.querySelector('.usp-bar-wrapper');
        if (uspBar) {
          uspBar.removeAttribute('hidden');
        }
      } else {
        this.init();
      }
    }, 1000);
  }

  disconnectedCallback() {
    // Stop the interval when the element is removed
    clearInterval(this.countdownInterval);
  }
}

// Define the custom element
customElements.define('countdown-timer-price', CountDownTimerPrice);

import { CartDrawer, CartNotificationDrawer } from "//www.liquid-life.de/cdn/shop/t/94/assets/theme.js?v=27372344513999645111746606423";

class CustomCartDrawer extends CartDrawer {
  constructor() {
    super(); // Call the constructor of the parent class
    // Add your event listener here
    this.init();
    //document.addEventListener("cart:ajax", () => {console.log('CART UPDATED VIA AJAX EVENT')});
  }

  init(){
    this.checkoutButton = this.querySelector('button[name="checkout"]');
    if (this.checkoutButton){
      if(JSON.parse(this.getAttribute('data-inited'))){
        return
      }
      this.checkoutButton.addEventListener('click', (e) => this.handleCartClick(e));
      this.checkoutButton.setAttribute('data-inited', true);
      this.userLoggedIn = JSON.parse(this.getAttribute('data-loggendin')); // TRUE FIELD
    }
  }

  handleCartClick(event) {
    // Your event handling logic here
    event.preventDefault();
    this.userLoggedIn = true; // with new Shopify login the login page is not needed, jump directly to checkout
    if(!this.userLoggedIn){
      window.location.href = '/account/login?return_url=%2Fcheckout';
    }else{
      window.location.href = '/checkout';
    }
  }
}
window.customElements.define("cart-drawer-x", CustomCartDrawer);

class CustomCartNotificationDrawer extends CartNotificationDrawer {
  constructor() {
    super(); // Call the constructor of the parent class

    this.checkoutButton = this.shadowRoot.querySelector('button[type="submit"]');
    if (this.checkoutButton){
      this.checkoutButton.addEventListener('click', (e) => this.handleCartClick(e));
      this.userLoggedIn = JSON.parse(this.getAttribute('data-loggendin')); // TRUE FIELD
    }
  }

  handleCartClick(event) {
    // Your event handling logic here
    event.preventDefault();
    this.userLoggedIn = true; // with new Shopify login the login page is not needed, jump directly to checkout
    if(!this.userLoggedIn){
      window.location.href = '/account/login?return_url=%2Fcheckout';
    }else{
      window.location.href = '/checkout';
    }
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  window.customElements.define("cart-notification-drawer-x", CustomCartNotificationDrawer);
});


class InfinityScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.init();
    this.scrollListener = () => this.handleScroll(); // Store the listener function reference
    document.addEventListener('scroll', this.scrollListener);

  }

  disconnectedCallback(){
    document.removeEventListener('scroll', this.scrollListener);
  }

  init(){
    this.loadMoreButton = this.querySelector('button');
    this.current = parseInt(this.getAttribute('data-current'));
    this.pages = JSON.parse(this.getAttribute('data-pages'));
    this.endPage = this.pages.slice(-1);
    this.pageData = {};
    this.loadingSoldOut = false;
    this.loadMoreButton.addEventListener('click', () => this.getProducts());
    this.scrollLoad = false;
    this.collectionContainer = document.querySelector('.collection product-list');
    this.language = JSON.parse(this.getAttribute('data-lang'));
  }

  handleScroll(){
    if(this.scrollLoad){
      if (this.isElementInViewport(this)) {
        this.getProducts();
        this.scrollLoad = false;
      }
    }
  }

  async getProducts() {
    this.loadMoreButton.textContent = this.language.loading;
    let current = this.current;
    let loadNumbers = this.pages.slice(0, 1);
    this.pages = this.pages.filter((_, i) => i >= 1);

    if (this.pages.length <= 0){
      this.setAttribute('hidden', true);
    }

    let tempDiv = document.createElement('div');
    let searchParams = new URL(window.location.href).searchParams;

    const queryParamsObject = {};
    for (const [key, value] of searchParams) {
      queryParamsObject[key] = value;
    }

    let productItemsContainer = document.createElement('div');

    //It was initially an array of 10 pages because i misunderstood the task
    //But ill leave it cuz it works and also can be used with await if wished to expand its function

    for (const i of loadNumbers){
      this.current++;
      queryParamsObject.page = this.current;
      let fetchURl = this.getURLBase() + '?' + this.createQueryString(queryParamsObject);
      let data = await this.getCollectionData(fetchURl);
      let productItems = data.targets.querySelectorAll('product-card');

      productItems.forEach((item) => {
        this.collectionContainer.append(item);
        if(item.hasAttribute('sold-out')){
          this.scrollLoad = false;
          this.loadMoreButton.textContent = this.language.load_more;
          this.loadingSoldOut = true;

        }else{
          this.scrollLoad = true;
        }
      })

      if (this.current >= this.endPage){
        this.setAttribute('hidden', true);
        return;
      }
    }

    //Keeping this in case the logic reverts
    if (this.current % 10 === 0) {
      this.scrollLoad = false;
      this.loadMoreButton.textContent = this.language.load_more;
    }else{
      this.scrollLoad = true;
    }
  }
  async getCollectionData(fetchURL) {
    try {
      const response = await fetch(fetchURL);
      const html = await response.text();
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      let targets = tempDiv.querySelector('[data-infinity-target]');
      return {
        targets: targets
      };
    } catch (error) {
      console.error('Error fetching data:', error);
      return {
        targets: null
      };
    }
  }

  getURLBase(){
    return location.protocol + '//' + location.host + location.pathname;
  }

  createQueryString(params) {
    const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
    return queryString;
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
window.customElements.define("infinity-scroll", InfinityScroll);

import { Drawer } from "//www.liquid-life.de/cdn/shop/t/94/assets/theme.js?v=27372344513999645111746606423";

class LocationDrawer extends Drawer {
  constructor() {
    super();
    this.data = JSON.parse(this.getAttribute('data-traffic'));
    this.times = {}
    this.locationsButton = document.querySelector(`[aria-controls="${this.getAttribute('id')}"]`);
    this.current = JSON.parse(this.getAttribute('data-current'));
    this.init(this.getAttribute("data-id"));

    if(localStorage.getItem('selectedLocation')){
      this.setButtonContent(localStorage.getItem('selectedLocation'))
    }

    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }


  addEventListeners(){
      this.chooseLocationButtons.forEach((button) => {
        button.addEventListener('click', this.handleLocationChange.bind(this))

      })
  }

  handleLocationChange(event){
    let locationsID = event.target.closest('[aria-controls]').getAttribute('aria-controls');
    if(locationsID){
      if(this.locationsButton){
          this.locationsButton.closest('form').querySelector('buy-buttons button').click();
      }
      localStorage.setItem('selectedLocation', locationsID)
      this.setButtonContent(locationsID);
    }
  }


  setButtonContent(locationsId){
    //this.locationsButton.querySelector('div').textContent = `${this.querySelector(`[data-location-time="${locationsId}"]`).innerText} | ${this.querySelector(`[data-location-time="${locationsId}"]`).closest('[data-container]').querySelector('[data-heading]').innerText}`;
  }

  handleVariantChange(event){
    let id = event.detail.variant.id.toString();
    let foundVariant = this.data.variants.find(v => v.id === id);
    this.current = foundVariant["stock"];
    this.removeAttribute('data-inited');
    //Initialize the Variant Max Times, as they could be different form the previous variant:
    this.times = {}
    
    this.init(id, localStorage.getItem('selectedLocation'));
  }


  init(id, optionalLocationID){
    let gid = id;
    let foundVariant = this.data.variants.find(v => v.id === id);
    this.querySelectorAll('[data-location-time]').forEach((locationItem) => {

      let locationGid = locationItem.getAttribute('data-location-time');
      let time = this.calcPickupDates(this.current,locationGid);

      let spanElement = locationItem.querySelector('span');

      //edit time if its already 5 hours befpre delivers:
      var germanyTime = new Date().toLocaleString("en-US", {timeZone: "Europe/Berlin"});
      var hours = new Date(germanyTime).getHours();
      
      if(time == 0 && hours >= 10){
        time = time+1;
      }
      
      let timeString;

      if (time == 0) {
        spanElement.textContent = this.getAttribute('data-sameday');
        timeString = this.getAttribute('data-sameday');
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      } else if (time == 1) {
        spanElement.textContent = this.getAttribute('data-xday').replace("[count]", time);
        timeString = this.getAttribute('data-xday').replace("[count]", time);
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      } else {
        spanElement.textContent = this.getAttribute('data-xdays').replace("[count]", time);
        timeString = this.getAttribute('data-xdays').replace("[count]", time);
        spanElement.classList.remove('text-warning');
        spanElement.classList.add('text-success');
      }

      if(!foundVariant.available){
        spanElement.textContent = this.getAttribute('data-soldout');
        timeString = this.getAttribute('data-soldout');
        spanElement.classList.add('text-warning');
        spanElement.classList.remove('text-success');       
      }

      if(locationGid === optionalLocationID){
          //this.locationsButton.querySelector('div').textContent = `${timeString} | ${this.querySelector(`[data-location-time="${optionalLocationID}"]`).closest('[data-container]').querySelector('[data-heading]').textContent}`;
      }

    })

    this.querySelectorAll('[data-location-stock]').forEach((locationItem) => {
      locationItem.classList.remove('text-error', 'text-warning', 'text-success');
    
      let locationGid = locationItem.getAttribute('data-location-stock');
      let stockAmount = this.current[locationGid];
    
      let spanElement = locationItem.querySelector('span');
      let dotElement = locationItem.querySelector('.pulse_dot');
    
      if (stockAmount <= 0) {
        spanElement.textContent = this.getAttribute('data-unavailable');
        spanElement.classList.add('text-warning');
        dotElement.style.setProperty("--dot-color", "var(--almostsoldout)");
      } else if (stockAmount > 0 && stockAmount <= 3) {
        spanElement.textContent = this.getAttribute('data-lowstock');
        spanElement.classList.add('text-warning');
        dotElement.style.setProperty("--dot-color", "var(--almostsoldout)");;
      } else if (stockAmount > 4) {
        spanElement.textContent = this.getAttribute('data-available');
        spanElement.classList.add('text-success');
        dotElement.style.setProperty("--dot-color", "var(--available)");
      }
    });


    if(!this.getAttribute('data-inited')){
      this.chooseLocationButtons = this.querySelectorAll('[data-chose-location]');
      this.addEventListeners();
      this.setAttribute('data-inited', true);
    }
  }



  calcPickupDates(metafieldObj, selectedLocation) {
    let maxDeliveryTime = 0;
    let locations = metafieldObj;
    let realQty = 1;
    let currentStock = metafieldObj;
        let tempTime = 0;
    
        switch (selectedLocation) {
          case '87280353589': //Zentrallager Neumann -> Ignore
            break;
          case '104355135797': //Zentrallager LL -> Ignore
            break;
          case '87280288053': //Store Brilon / LL Brilon
            //If Store Brilon and ZL Neumann and ZL LL have enough Stock: Sameday
            if((currentStock['87280288053'] + currentStock['87280353589'] + currentStock['104355135797']) >= realQty){
              //console.log('neumann stock', tempTime);
            }else{
              //If Neumann Brilon (STORE!) has Stock, waiting Day is 1
              if(currentStock['86341058869'] >= realQty){
                tempTime = 1;
              }else{
                tempTime = 4;
              }
            }
          break; 
          
          case '86341058869': //Neumann Brilon
          if((currentStock['86341058869']) >= realQty){
          }
          else{
            //IF Store Brilon has and/or Zentrallager Neumann and Zentrallager LL has Stock
            if((currentStock['87280288053'] + currentStock['87280353589'] + currentStock['104355135797']) >= realQty){
              tempTime = 1;
            }else{
              tempTime = 4;
            }
          }
          break;
          
          case '87280484661': // Bielefeld
            if(currentStock['87280484661'] >= realQty){
              //Bielefeld has Stock, nothing Changes
            }else{
              tempTime = 4;
            }
            break;
          
          
          case '87280451893': // Cube Store Paderborn
          if(currentStock['87280451893'] >= realQty){
            //Bielefeld has Stock, nothing Changes
          }else{
            tempTime = 4;
          }
          break;
          default: 47 
        }    
        if (this.times[selectedLocation] === undefined || this.times[selectedLocation] < tempTime) {
          this.times[selectedLocation] = tempTime;
        }
    return this.times[selectedLocation];
  }

  }


window.customElements.define("x-drawer-location", LocationDrawer);


import { VariantPicker } from "//www.liquid-life.de/cdn/shop/t/94/assets/theme.js?v=27372344513999645111746606423";
class TMVariantPicker extends VariantPicker {
  constructor() {
    super();
    this.data = JSON.parse(this.querySelector('[data-traffic-json]').innerHTML);
    this.maxOptions = this.getAttribute('data-maxoptions');
    this.current = this.getAttribute('data-current-variant');
    this.pickerDrawer = this.querySelector('x-drawer');
    if (this.pickerDrawer) {
      this.drawerSelector = this.pickerDrawer.querySelector('.variant-picker__option-values');
    } else {
      this.drawerSelector = null;
    }
    this.init();
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  hasSubArray(master, sub) {
    return sub.every((item => value => item = master.indexOf(value, item) + 1)(0));
  }

  handleVariantChange(event) {
    if (event.detail?.variant?.id) {
      this.setColor(event.detail.variant.id.toString());
    }
  }

  init() {
    this.setColor(this.current);
  }

  setColor(id) { 
    if (this.drawerSelector) {
        this.drawerSelector.innerHTML = '';
      
        const otherSizes = [
          "4", "4.0", "4.5",
          "5", "5.0", "5.5",
          "6", "6.0", "6.5",
          "7", "7.0", "7.5",
          "8", "8.0", "8.5",
          "9", "9.0", "9.5",
          "10", "10.0", "10.5",
          "11", "11.0", "11.5",
          "12", "12.0", "12.5",
          "22", "22.0", "22.5",
          "23", "23.0", "23.5",
          "24", "24.0", "24.5",
          "25", "25.0", "25.5",
          "26", "26.0", "26.5",
          "27", "27.0", "27.5",
          "28", "28.0", "28.5",
          "29", "29.0", "29.5",
          "30", "30.0", "30.5",
          "31", "31.0", "31.5",
          "32", "32.0", "32.5",
          "33", "33.0", "33.5",
          "34", "34.0", "34.5",
          "35", "35.0", "35.5",
          "36", "36.0", "36 2/3", "36.5",
          "37", "37.0", "37 1/3", "37.5",
          "38", "38.0", "38 2/3", "38.5",
          "39", "39.0", "39 1/3", "39.5",
          "40", "40.0", "40 1/3", "40.5", "40 2/3",
          "41", "41.0", "41 1/3", "41.5",
          "42", "42.0", "42 1/3", "42.5", "42 1/2", "42 2/3",
          "43", "43.0", "43 1/3", "43.5", "43 1/2",
          "44", "44.0", "44 1/2", "44.5", "44 2/3",
          "45", "45.0", "45 1/3", "45.5",
          "46", "46.0", "46 2/3", "46.5",
          "47", "47.0", "47 1/3", "47.5",
          "48", "48.0", "48.5",
          "49", "49.0", "49 1/3", "49.5",
          "50", "50.0", "50.5", "50 2/3"
        ];
        
        const helmetSizes = [
          "46-51", "47-48", "48-52", "49-50", "49-53", "49-54", "49-55", "50-54", "50-55", "50-56", "50-57",
          "51-52", "51-53", "51-54", "51-55", "51-56", "51-57", "52-54", "52-55", "52-56", "52-57", "52-58",
          "53-54", "53-55", "53-56", "53-60", "54-56", "54-58", "54-59", "54-60", "54-61", "55-56", "55-57",
          "55-58", "55-59", "56-58", "56-59", "56-60", "56-61", "56-62", "57-58", "57-59", "57-61", "57-62",
          "58-59", "58-60", "58-61", "58-62", "58-63", "59-60", "59-61", "59-62", "59-63", "59-64", "60-61",
          "60-62", "60-63", "60-64", "61-62", "61-63", "61-65", "62-63", "63-64", "63-65"
        ];
        
        const clothingSizes = [
          "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "3XL", "4XL", "XXXXL", "5XL", "XXXXXL", "6XL"
        ];
        
        const sizeOrder = [...otherSizes, ...helmetSizes, ...clothingSizes];    
      
        const { general, variants } = this.data;
        
        variants.sort((a, b) => {
            const indexA1 = sizeOrder.indexOf(a.option1);
            const indexA2 = sizeOrder.indexOf(a.option2);
            const indexB1 = sizeOrder.indexOf(b.option1);
            const indexB2 = sizeOrder.indexOf(b.option2);
        
            const indexA = indexA1 !== -1 ? indexA1 : (indexA2 !== -1 ? indexA2 : sizeOrder.length);
            const indexB = indexB1 !== -1 ? indexB1 : (indexB2 !== -1 ? indexB2 : sizeOrder.length);
        
            return indexA - indexB;
        });        

        const foundVariant = variants.find(v => v.id === id);
        if (!foundVariant) {
            console.warn(`Variant with ID ${id} not found`);
            return;
        }

        const optionsLookup = foundVariant.options.slice(0, -1);

        const optionNr = foundVariant.options.length === 2 ? 'option2' : 'option1';

        const foundColorVariants = variants.filter(v =>
            v.options.slice(0, -1).every((option, index) => option === optionsLookup[index])
        );

        if (!foundColorVariants.length) {
            console.warn(`No color variants found for options:`, optionsLookup);
            return;
        }

        foundColorVariants.forEach(colorVariant => {
          let dotColor
          if (!colorVariant.status) {
            if (colorVariant.inventory_quantity > 0) {
              dotColor = "--available";       
            } else {
              dotColor = "--unavailable";
            }
          } else {
            dotColor = colorVariant.color;
          }

          let animationClass
          if (colorVariant.color == "--unavailable"){
             animationClass = "pulse_dot--no_animate";
          }

          const status = colorVariant.status
              ? colorVariant.status.replace(/, /g, " / ").replace(/ - /g, "-")
              : "";
          const value = colorVariant.options.slice(-1)[0];
          const formID = `${general.form_id}${optionNr}-${value.toLowerCase().replace(/ /g, "-")}`;

          const label = document.createElement('label');
          label.className = `picker2-swatch dropdown-swatch dropdown--swatch-new ${colorVariant.id === id ? "is-selected" : ""}`;
          label.setAttribute('for', formID);
          label.setAttribute('id', colorVariant.id);
          label.setAttribute('ean', colorVariant.ean);
          label.setAttribute('data-option-value', value);

          let bodySize = "";
          if (colorVariant.bodysize !== "") {
              bodySize = '<span class="break-after">Körpergröße </span>' + colorVariant.bodysize + '*';
          }
          
          label.innerHTML = `
              <div class="dropdown-swatch__info">
                  <span class="ll_variant_selected" style="font-size: var(--text-h6); line-height: var(--text-h6)">${value}</span>
                  <span>${bodySize}</span>
                  <span class="ll_last_variant_selected text-sm" style="color: var(${dotColor})">${status.replace('Auf Lager /', '<span class="break-after">Lieferzeit </span>').replace('Bald wieder ', '<span class="break-after">Bald wieder </span>').replace('<span class="break-after">Lieferzeit </span> 1-2 Werktage', 'Lieferung innerhalb 48 Stunden')}</span>
                  <div class="pulse_dot ${animationClass}" style="--dot-color: var(${dotColor})"></div>
              </div>
          `;

          const input = document.createElement('input');
          input.className = 'sr-only';
          input.type = 'radio';
          input.name = optionNr;
          input.id = formID;
          input.value = value;
          input.setAttribute('form', general.form);
          if (colorVariant.id === id) {
              input.checked = true;
          }

          this.drawerSelector.appendChild(input);
          this.drawerSelector.appendChild(label);
      });
    }
  }
}
window.customElements.define("variant-picker-tm", TMVariantPicker);

class WishlistButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      this.toggleState(e);
    });
  }

  // Function to toggle the state
  toggleState(e) {

    let item = this;

    let product = {
      epi: parseInt(this.getAttribute('data-variant-id')),
      empi: parseInt(this.getAttribute('data-product-id')),
      du: parseInt(this.getAttribute('data-product-url'))
    }
  }
}

// Define the custom element 'wishlist-button' associated with the <button> tag
customElements.define('wishlist-button', WishlistButton, { extends: 'button' });

// algolia search
document.addEventListener('algolia.autocomplete.afterInit', function() {
  const inputElement = document.querySelector('.aa-MainContainer .aa-Autocomplete .aa-Form .aa-Input');

  if (inputElement) {
    inputElement.addEventListener('input', function() {
      if (inputElement.value === '') {
        document.querySelector('[data-startup-container]').removeAttribute('hidden');
      } else {
        document.querySelector('[data-startup-container]').setAttribute('hidden', '');
      }
    });
  }
});



// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    //console.log("debug options", options);

    if(getLanguageByDomain() == "de") {
      options.numberLocale = 'de';
    }

    setAlgoliaSearchTranslations();

    return options;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {
    //console.log("item", item);
    return html`
      <label class="${item.cssClasses.label}">
        ${item.type === 'disjunctive' &&
          (item.isRefined
            ? html`
                <input
                  type="checkbox"
                  class="${item.cssClasses.checkbox}"
                  checked
                />
              `
            : html`
                <input type="checkbox" class="${item.cssClasses.checkbox}" />
              `)}
        <span>${item.label}</span><span class="text-sm">${algoliaShopify.helpers.formatNumber(item.count)}</span> 
        <span class="${item.cssClasses.count}">
          ${algoliaShopify.helpers.formatNumber(item.count)}
        </span>
      </label>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          <div class="text-with-icon justify-center"><svg role="presentation" fill="none" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-filter" viewBox="0 0 20 14">
            <path d="M1 2C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4V2ZM1 4H5V2H1V4Z" fill="currentColor"></path>
            <path d="M1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12V10ZM1 12H11V10H1V12Z" fill="currentColor"></path>
            <path d="M10 2H9V4H10V2ZM19 4C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2V4ZM10 4H19V2H10V4Z" fill="currentColor"></path>
            <path d="M16 10H15V12H16V10ZM19 12C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10V12ZM16 12H19V10H16V12Z" fill="currentColor"></path>
            <circle cx="7" cy="3" r="2" stroke="currentColor"></circle>
            <circle cx="13" cy="11" r="2" stroke="currentColor"></circle>
            </svg><span style="font-weight: bold;">Filtern und sortieren</span>
          </div>
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" >    
                  <label class="facet-label" data-facet-name="${facet.escapedName}">
                    <div class="accordion__toggle">                   
                      <span class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</span>
                      <span class="default-chevron">
                        <svg role="presentation" focusable="false" width="10" height="7" class="icon icon-chevron-bottom" viewBox="0 0 10 7">
                          <path d="m1 1 4 4 4-4" fill="none" stroke="currentColor" stroke-width="2"></path>
                        </svg>
                      </span>                   
                    </div>
                  </label>
                  <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown"/>                  
                  <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container" data-facet-name="${facet.escapedName}" hidden></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
          <span class="ais-h2" style="display:block; color:#000000; text-align: left;">${algoliaShopify.translations.searchTitle}</span>
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
  
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(defaultTemplate, data, html, components) {
    const product = transformItem(data);
    const productHtml = renderProductCard(product, html, true);

    return productHtml;
  });

  algoliaShopify.hooks.registerHook('beforeISFacetSearchablePlaceholderString', function(placeHolder, facet) {
    if(getLanguageByDomain() == "de") {
      placeHolder = placeHolder.replace('Search for', 'Suche nach');
    }

    return placeHolder;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    options.placeholder = document.querySelector('.header__desktop-search-input .search-input-field input').placeholder;
    options.numberLocale = 'de_DE';
    //options.debug = true;

    document.documentElement.style.setProperty('--aa-detached-media-query', '(max-width: 1px)');
    document.documentElement.style.setProperty('--aa-detached-modal-media-query', '(min-width: 1px)');

    setAlgoliaSearchTranslations();

    function debouncePromise(fn, time) {
      let timerId;
    
      return function debounced(...args) {
        if (timerId) {
          clearTimeout(timerId);
        }
    
        return new Promise((resolve) => {
          timerId = setTimeout(() => resolve(fn(...args)), time);
        });
      };
    }

    if (options.getSources && typeof options.getSources === 'function') {
      options.getSources = debouncePromise(options.getSources, 300);
    } else {
      options.getSources = debouncePromise(() => Promise.resolve([]), 300);
    }

    return options;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(_defaultTemplate, templateOptions, distinct, itemLink) {
    const { html, state } = templateOptions;
    const { item } = templateOptions;

    const product = transformItem(item);
    const productHtml = renderProductCard(product, html, false);

    return productHtml;

    /*
    default template
    var { title, variant_title, barcode, sku, handle, compare_at_price, price, product_image, vendor, } = item;

    const dotIndex = product_image.lastIndexOf('.');
    if (dotIndex !== -1) product_image = product_image.substring(0, dotIndex) + '_400x400' + product_image.substring(dotIndex);

    price = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);

    return html`
      <a href="/products/${handle}" class="aa-ItemLink aa-ProductItem">
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded"><img src="${product_image}" alt="${title}"></div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentBrand">${vendor}</div>
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">${title}</div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">${price}</div>
            </div>
          </div>
          </div>
      </a>
    `;
     */
  });
});

/**
 * Renders the Product Card HTML
 *
 * To Do:
 * - Add Variant Availability
 */
const renderProductCard = (product, html, resultpage) => {
  /**
   * Badges
   *
   * To Do:
   * - Add Flash Sale badge
   */
  const renderProductBadges = (badgeTypes, className, html) => {
    badgeTypes = badgeTypes || ['sold_out', 'discount', 'financing'];
    const badges = badgeTypes
      .filter(type => {
        switch (type) {
          case 'sold_out':
            return !product.available;
          case 'discount':
            return product.compare_at_price > product.price && product.available;
          case 'financing':
            return product.meta.custom.is_product_a_bike && product.variants_inventory_count > 0;      
          default:
            return false;
        }
      })
      .reduce((acc, type) => {
        switch (type) {
          case 'sold_out':
            acc['sold_out'] = html`
              <sold-out-badge class="badge badge--sold-out">
                ${window.themeVariables.strings.soldOutBadge}
              </sold-out-badge>
            `;
            break;
          case 'discount':
            const savingsPercentage = `${Math.round((product.compare_at_price - product.price) * 100.0 / product.compare_at_price)}%`;
            const savingsInfo = window.themeVariables.strings.discountBadge.replace('%savings%', savingsPercentage);
            acc['discount'] = html`
              <on-sale-badge discount-mode="percentage" class="badge__pdp badge--on-sale">${savingsInfo}</on-sale-badge>
            `;
            break;
          case 'financing':
            acc['financing'] = html`
              <span class="badge__pdp badge--flash-discount" style="--badge-background: #FFF; --text-color: 21 21 21; border:1px solid #151515">0% Finanzierung</span>
            `;
            break;
        }
        return acc;
      }, {});

    if (badges.length < 1) return html``;

    // Now you can use it like this:
    const soldOutBadge = badges['sold_out'] ?? html``;
    const discountBadge = badges['discount'] ?? html``;
    const financingBadge = badges['financing'] ?? html``;

    return html`
      <div class="${className}">
        ${soldOutBadge}${discountBadge}${financingBadge}
      </div>
    `;
  }

  /**
   * Vendor Logo
   */
  const renderVendorLogo = (html) => {
    if (!product.vendor?.logo) return '';

    return html`
      <a href="${product.vendor.collectionUrl}" class="product-card__vendor-logo uppercase">
        <img src="${product.vendor.logo}" width="80" loading="lazy" class="vendor-logo">
      </a>
    `;
  };

  /**
   * Free Shipping
   */
    const renderFreeShipping = (html) => {
      const tags = product.tags;

      const containsBikeOrEbike = tags.includes("E-Bike") || tags.includes("Fahrrad");
      const containsKids = tags.includes("Kids");
      
      if (containsBikeOrEbike && !containsKids) {
        return html`
          <span style="font-size: 13px; font-weight: 600; margin-top: 5px; margin-bottom: 2px">GRATIS Premium Versand</span>
        `;
      }      
    };

/**
 * Free Shipping
 */
    const renderUSP = (html) => {
      if (!product.meta.custom.usp) return '';

      return html`
        <span class="usp">${product.meta.custom.usp}</span>
      `;    
    };

  /**
   * Price List
   *
   * To Do:
   * - Add 'From' price
   */
  const renderPriceList = (html) => {
    const { price, compare_at_price } = product;
    const isOnSale = compare_at_price > price;
    const priceSaving = compare_at_price - product.price;

    const renderComparePrice = (html) => {
      if (!isOnSale) return '';

      return html`
        <compare-at-price>
          <span class="sr-only">Regulärer Preis</span>          
          <span class="line-through" style="font-size: 13px">${formatPrice(compare_at_price)}</span>
          <price-savings>  Du sparst ${formatPrice(priceSaving)}</price-savings>
        </compare-at-price>
      `;
    };

    const renderFinancing = (html) => {
      if (product.price < 99) return '';
      const r = (9.70 / 100) / 12;
      const n = 60;
      const financingRate = (product.price * r) / (1 - Math.pow(1 + r, -n));

      return html`
        <financing-info>
          <button class="product-info__financing">          
              <div class="link-financing">oder ab ${formatPrice(financingRate)} / Monat</div>          
          </button>        
        </financing-info>              
      `;  
    };

    return html`
      <price-list class="price-list">
        <sale-price class="${isOnSale ? 'text-on-sale' : ''}" style="font-size:var(--text-lg)">
          <span class="sr-only">Angebot</span>${formatPrice(product.price)}*
        </sale-price>
        ${renderComparePrice(html)}
        ${renderFinancing(html)}
      </price-list>
    `;
  };

  /**
   * Color Options
   */ 
  const renderColorOptions = (productImage, html) => {
    const renderEmptyElement = (html) => {
      return html`
        <a href="${product.url}?variant=${product.objectID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${productImage}" hidden/>
        </a>
      `;
    };
    
    if (!product || !product.meta || !product.meta.custom || !product.meta.custom.algolia_variants) {
      return html`
        ${renderEmptyElement(html)}
      `;
    }
    const algolia_variants_full = JSON.parse(product.meta.custom.algolia_variants);
    
    algolia_variants_full.sort((a, b) => {
      if (a.variantID == product.objectID) {
          return -1;
      } else if (b.variantID == product.objectID) {
          return 1;
      } else {
          return 0;
      }
    });
    
    const seenImages = new Set();
    const algolia_variants = algolia_variants_full.filter(variant => {
        //if (variant.variantInventory === 0) {
        //  return false;
        //}
        if (seenImages.has(variant.variantImage)) {
          return false;
        } else {
            seenImages.add(variant.variantImage);
          return true;
        }
    });
    
    if (algolia_variants.length === 0) {
      return html`
        ${renderEmptyElement(html)}
      `;
    }
    
    const countOfVariants = algolia_variants.length;

    if (algolia_variants[0].variantTitle.length < 3) {
      return html`
        ${renderEmptyElement(html)}
      `;
    }
    
    if(countOfVariants == 2) {      
      return html`
        <a href="${product.url}?variant=${algolia_variants[0].variantID}" class="media-swatch media-swatch--xs is-selected">
          <img class="object-contain" src="${algolia_variants[0].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[1].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[1].variantImage}" />
        </a>
      `;
    }else if(countOfVariants == 3){
      return html`
        <a href="${product.url}?variant=${algolia_variants[0].variantID}" class="media-swatch media-swatch--xs is-selected">
          <img class="object-contain" src="${algolia_variants[0].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[1].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[1].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[2].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[2].variantImage}" />
        </a>
        `;      
    }else if(countOfVariants == 4){      
      return html`
        <a href="${product.url}?variant=${algolia_variants[0].variantID}" class="media-swatch media-swatch--xs is-selected">
          <img class="object-contain" src="${algolia_variants[0].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[1].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[1].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[2].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[2].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[3].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[3].variantImage}" />
        </a>
        `;
    }else if(countOfVariants > 4){      
      return html`
        <a href="${product.url}?variant=${algolia_variants[0].variantID}" class="media-swatch media-swatch--xs is-selected">
          <img class="object-contain" src="${algolia_variants[0].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[1].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[1].variantImage}" />
        </a>
        <a href="${product.url}?variant=${algolia_variants[2].variantID}" class="media-swatch media-swatch--xs">
          <img class="object-contain" src="${algolia_variants[2].variantImage}" />
        </a>
        <a href="${product.url}" data-instant="" class="media-swatch__view-more more_variants">+${countOfVariants-3}</a>
        `;      
    }else{
      return html`
        ${renderEmptyElement(html)}
      `;
    }
  };
  /**
   * On Stock Badge
   */ 
  const renderOnStockBadge = (html) => {
    if (product.variants_inventory_count == 0) return '';

    return html`
        <variants-availability class="product-card__variant-availability">
          <span data-variant-href="${product.url}" class="product-card__variant product-card__variant--available" data-available-variant="">Auf Lager</span>
        <div class="product-card__variant product-card__variant--available" data-in-stock="" hidden="">Auf Lager</div></variants-availability>
    `;
  };

      
  const style = `--background: ${window.themeVariables.settings.colors.productCardBackground};--text-color: ${window.themeVariables.settings.colors.productCardTextColor};`;

  let productImage = 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
  if(product.product_image !== null) productImage = getSizedImageUrl(product.product_image, '400x400');
  if(product.image !== null) productImage = getSizedImageUrl(product.image, '400x400');

  if (product.title.startsWith(product.vendor)) {
    product.title = product.title.slice(product.vendor.length).trim();
  }

  const htmlOutput = html`
    <product-card 
      class="ais-hit ais-product product-card bg-custom text-custom" 
      style="${style}" 
      data-handle="${resultpage ? product.handle : ""}"
      data-product-id="${resultpage ? product.id : ""}"
      data-variant-id="${resultpage ? product.objectID : ""}" 
      onClick="${() => algoliaShopify.helpers.handleItemClick(product)}">    
      <div class="product-card__figure">
        <a data-gtm-event="product-card_search#image" href="${product.url}?variant=${product.objectID}">
          <img class="product-card__image product-card__image--primary aspect-bike" src="${productImage}" />
        </a>
        ${renderVendorLogo(html)}
      </div>      
      <div class="product-card__info">
        <div class="product-card__info-inner v-stack gap-1 w-full">
          <div class="product-card__aside">
            <fieldset class="product-card__variant-list">
              ${renderColorOptions(productImage, html)}
            </fieldset>
          </div>
          <div class="v-stack">
            <a href="${product.vendor?.collectionUrl}" class="text-xs product-card__vendor uppercase">${product.vendor}</a>
            <span class="product-card__title">
              <a data-gtm-event="product-card_search#title" href="${product.url}">${product.title}</a>
            </span>
            ${renderUSP(html)}
          </div>          
          <div class="product-card__price-block">
            ${renderProductBadges(['discount', 'sold_out'], 'product-card__badge-list product-card__badge-list--desktop', html)}  
            ${renderPriceList(html)}
            ${renderFreeShipping(html)}
          </div>          
        </div>
        ${renderOnStockBadge(html)}
      </div>
    </product-card>
  `;

  return htmlOutput
};

/**
 * Formats price correctly from Algolia price
 */
const formatPrice = (price) => formatMoney(price * 100);

/**
 * Maps results response to add new Product properties
 */
const transformItem = (item) => {
  item.available = item.inventory_quantity > 0;
  item.url = `/products/${item.handle}`;

  return item;
}

/**
 * Gets all vendor information from the vendor name
 */
const getVendor = (vendorName, vendors) => {
  const vendor = vendors.find(vendor => vendor.name === vendorName);
  if (vendor) return vendor;

  return {
    name: vendorName
  }
}

const getLanguageByDomain = () => {
  const url = new URL(window.location.href);
  const hostname = url.hostname;

  if (hostname.endsWith(".de")) {
    return "de";
  } else if (hostname.endsWith(".com")) {
    return "en";
  } else {
    return "de";
  }
}

const setAlgoliaSearchTranslations = () => {
  if(getLanguageByDomain() == "de") {
    algoliaShopify.translations.collections = "Kategorien";
    algoliaShopify.translations.clearAll = "Alle zurücksetzen";
    algoliaShopify.translations.noResultFor = "Keine Ergebnisse für";
    algoliaShopify.translations.outOf = "von";
    algoliaShopify.translations.pages = "Seiten";
    algoliaShopify.translations.suggestions = "Suchvorschläge";
    algoliaShopify.translations.searchForProduct = "Suche";
    algoliaShopify.translations.selectedFilter = "Ausgewählte Filter";
    algoliaShopify.translations.products = "Produkte";
    algoliaShopify.translations.showMore = "Mehr anzeigen";
    algoliaShopify.translations.showLess = "Weniger anzeigen";
    algoliaShopify.translations.search = "Suche";
    algoliaShopify.translations.searchTitle = "Suchergebnisse";
    algoliaShopify.translations.resultsFound = "Ergebnisse gefunden";
    algoliaShopify.translations.articles = "Artikel";
    algoliaShopify.translations.allProducts = "Alle Produkte ";
    algoliaShopify.translations.sortBy = "Sortieren nach";
    algoliaShopify.translations.noResultFound = "Keine Ergebnisse gefunden";
    algoliaShopify.translations.oneResultFound = "1 Ergebnis gefunden";
    algoliaShopify.translations.relevance = "Unsere Empfehlung";
    algoliaShopify.translations.articles = "Artikel";


    if(typeof algoliaShopify.translations.facets !== "undefined" && Array.isArray(algoliaShopify.translations.facets)) {
      for (let i = 0; i < algoliaShopify.translations.facets.length; i++) {
        algoliaShopify.translations.facets[i].title = algoliaShopify.translations.facets[i].title.replace("Price range", "Preisspanne").replace("Price", "Preis").replace("Vendor", "Marken").replace("Type", "Kategorien").replace("Selected filters", "Filter");
      }
    }
  }
}

function setAlgoliaProductCardHeight() {
  const produkte = document.querySelectorAll('.ais-page .ais-product, .aa-Panel .ais-product');
  if (produkte.length === 0) return;

  let maxHoehe = 0;
  produkte.forEach(element => {
    element.style.height = 'auto'; // Höhe zurücksetzen
    maxHoehe = Math.max(maxHoehe, element.offsetHeight);
  });

  produkte.forEach(element => {
    element.style.height = `${maxHoehe}px`;
  });
}

window.addEventListener('load', setAlgoliaProductCardHeight);
window.addEventListener('resize', setAlgoliaProductCardHeight);

/*JSON Pickup Locations*/

class VariantLocations extends HTMLElement {
  constructor() {
    super();
    this.locations = JSON.parse(this.getAttribute('data-stocks'));

  }


  connectedCallback(){
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  disconnectedCallback(){
    document.removeEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  handleVariantChange(event){
      let variant = event.detail.variant;
      //this.locations.forEach((item) => console.log(Object.keys(item)[0]))
      let foundVariant = this.locations.find((item) => Object.keys(item)[0] === variant.id.toString());
      //console.log(foundVariant);
  }

}

window.addEventListener('scroll', function() {
    var searchDrawer = document.querySelector('.search-drawer');
    if (window.scrollY > 0) {
        searchDrawer.style.top = '0';
    } else {
        searchDrawer.style.top = '34px';
    }
});

document.addEventListener('DOMContentLoaded', function() {
    function getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    const searchQuery = getParameterByName('q');

    if (searchQuery) {
        const searchInput = document.getElementById('search-input');
        if (searchInput) {
            searchInput.placeholder = searchQuery;
        }
    }
});

function algoliaFacetListeners() {
    const labels = document.querySelectorAll('label.facet-label');
    labels.forEach(function(label) {
        if (!label.dataset.listenerAdded) {
            label.addEventListener('mouseup', function(event) {
                var chevron = this.querySelector('.icon-chevron-bottom');
                if (chevron) {
                    chevron.classList.toggle('rotate');
                }
                var facetName = this.dataset.facetName;
                var dropdownContainers = document.querySelectorAll('.ais-facet-dropdown-container');
                
                dropdownContainers.forEach(function(container) {
                    if (container.dataset.facetName === facetName) {
                        container.toggleAttribute('hidden');
                    }
                });
            });
            label.dataset.listenerAdded = 'true';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    algoliaFacetListeners();
    const facetObserver = new MutationObserver(algoliaFacetListeners);
    facetObserver.observe(document.body, { childList: true, subtree: true });
});

customElements.define('variant-locations', VariantLocations);

function addClickListenerToPaymentButton() {
    const button = document.querySelector('.shopify-payment-button');

    if (button) {
      button.addEventListener('click', function() {       
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'dynamic_checkout_button_clicked',
        });
      });
    }
}



const shopify_payment_button_observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            addClickListenerToPaymentButton();
        }
    });
});

shopify_payment_button_observer.observe(document.body, {
    childList: true,
    subtree: true
});

function addClickListenerToFinanceButtons() {
    const buttons = document.querySelectorAll('financing-info[aria-controls="FinancingDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-financing_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToFinanceButtons);

function addClickListenerToShippingButtons() {
    const buttons = document.querySelectorAll('a[aria-controls="ShippingInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-shipping_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToShippingButtons);

function addClickListenerToShippingEquipmentButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="ShippingEquipmentDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-shipping_equipment_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToShippingEquipmentButtons);

function addClickListenerToRefundButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="RefundsInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-refund_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToRefundButtons);

function addClickListenerToNewsletterButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="NewsletterInformationDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-newsletter_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToNewsletterButtons);

function addClickListenerToLeasingButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="LeasingDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-leasing_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToLeasingButtons);

function addClickListenerToBestPriceButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="BestPriceDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-best_price_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToBestPriceButtons);

function addClickListenerToAufbauserviceButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="AufbauserviceDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-aufbauservice_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToAufbauserviceButtons);

function addClickListenerToSupportButtons() {
    const buttons = document.querySelectorAll('button[aria-controls="SupportDrawer"]');
    buttons.forEach(button => {
        button.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'pdp-support_button_clicked',
          });
        });
    });
}
document.addEventListener('DOMContentLoaded', addClickListenerToSupportButtons);

document.addEventListener('DOMContentLoaded', function () {
    // Funktion, um ein Ereignis an den GTM zu senden
    function sendNavEventToGTM(href) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'navigationClick',
            eventCategory: 'Navigation',
            eventAction: 'Click',
            eventLabel: href
        });
    }
    const header = document.querySelector('.header');
    const navDrawer = document.querySelector('navigation-drawer');
    function monitorLinksInContainer(container) {
        if (container) {
            const navLinks = container.querySelectorAll('a');
            const spanLinks = container.querySelectorAll('span[data-href]');
            navLinks.forEach(function(link) {
                link.addEventListener('click', function(event) {
                    const href = link.getAttribute('href');
                    sendNavEventToGTM(href);
                });
            });
            spanLinks.forEach(function(span) {
                span.addEventListener('click', function(event) {
                    const href = span.getAttribute('data-href');
                    sendNavEventToGTM(href);
                });
            });
        }
    }
    monitorLinksInContainer(header);
    monitorLinksInContainer(navDrawer);
});

document.addEventListener('DOMContentLoaded', function () {
    function sendEventToGTM(eventLocation, eventCategory, href, currentUrl) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ahrefClick',
            eventLocation: eventLocation,
            eventCategory: eventCategory,
            eventTarget: href,
            eventSource: currentUrl 
        });
    }
    document.body.addEventListener('click', function (event) {
        let link = event.target.closest('a[data-gtm-event]');
        if (!link) return;
        const gtmEvent = link.getAttribute('data-gtm-event');
        const href = link.getAttribute('href');
        const currentUrl = window.location.href;
        if (gtmEvent && href) {
            const [eventLocation, eventCategory] = gtmEvent.split('#');
            sendEventToGTM(eventLocation, eventCategory, href, currentUrl);
        }
    });
});

// Scroll-Position, ab der die Sticky-Funktion aktiviert wird
document.addEventListener('DOMContentLoaded', () => {
    const product_gallery = document.querySelector('.product-gallery');
    const artikelSection = document.querySelector('.shopify-section.shopify-section-artikel-dieser-kategorie');
    const mobileContainer = document.querySelector('.container_mobile.container');

    if (product_gallery && artikelSection && mobileContainer) {
        const artikelHeight = artikelSection.offsetHeight;
        const mobileContainerHeight = mobileContainer.offsetHeight;
        const startStickyScrollPosition = artikelHeight + mobileContainerHeight; 

        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;

            if (currentScroll >= startStickyScrollPosition) {
                product_gallery.classList.add('sticky');
            } else {
                product_gallery.classList.remove('sticky');
            }
        });
    }
});

window.sendAlgoliaEvent = function(action, objectIDs) {
  aa("init", {
    appId: "DOWRDBU35W",
    apiKey: "da1ad753b1212cc9a7439c63c819ddc6",
  });

  switch (action) {
    case "product_viewed":
      window.aa("viewedObjectIDs", {
        index: "shopify_live_store_de_products",
        eventName: "productViewed",
        objectIDs: objectIDs
      });
      break;

    case "product_clicked":
      window.aa("clickedObjectIDs", {
        index: "shopify_live_store_de_products",
        eventName: "productClicked",
        objectIDs: objectIDs
      });
      break;
      
    case "collection_viewed":
      window.aa("viewedObjectIDs", {
        index: "shopify_live_store_de_collections",
        eventName: "collectionViewed",
        objectIDs: objectIDs
      });
      break;

    case "collection_clicked":
      window.aa("clickedObjectIDs", {
        index: "shopify_live_store_de_collections",
        eventName: "collectionClicked",
        objectIDs: objectIDs
      });
      break;
    default:
      console.error("Unbekannte Aktion:", action);
  }
};
document.addEventListener('variant:change', (event) => {
  const drawers = document.querySelectorAll('x-drawer');
  drawers.forEach(drawer => {
      drawer.style.opacity = '0';
      drawer.style.visibility = 'hidden';
      drawer.removeAttribute('open');
  });
});